// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * ## Interactive Documentation ##### Our API documentation allows you to test API calls straight from this website. ##### To do this, scroll down a little and click the green \"Authorize\" button (with a padlock) to the right and below. A pop-up should appear. ##### In the popup, enter your \"client_id\" and \"client_secret\" values (these will be provided to you) and press \"Authorize\". You should now be logged in (you can open up your network tab to see the API traffic going through). ##### From here, you can click any endpoint below to expand its details and click the \"Try it out\" button that appears in the expanded section. ##### Fill out the parameter fields and then click \"Execute\" to call the endpoint. The results of your query should be shown below. ## Authentication ##### Our API uses the OAuth 2.0 Client Credentials flow to authorize clients. ##### With your provided \"Client Id\" and \"Client Secret\", make the following call: ``` POST /oauth/token HTTP/1.1 Host: api.enter.health  grant_type=client_credentials &client_id=XXXXXXXXXXXX &client_secret=YYYYYYYYYYY ``` ##### Here\'s an example CURL request: ``` curl \'https://api.enter.health/oauth/token\' -H \'accept: application/json\' --data \'grant_type=client_credentials&client_id=XXXXXXXXXXXX&client_secret=YYYYYYYYYYY\' ``` ##### The response should look something like this ``` {   \"access_token\" : \"AAAAAAAAAAAAAAAAAAA\",   \"refresh_token\" : \"BBBBBBBBBBBBBBBBBBB\" }  ``` ##### With the access token provided, you can make an authenticated call to any of the endpoints below by including the header \"Authorization: Bearer AAAAAAAAAAAAAAAAAAA\" with your API request. ##### Here\'s an example of a basic curl request to the \"/me\" endpoint ``` curl \'https://api.enter.health/me\' -H \'accept: application/json\' -H \'authorization: Bearer AAAAAAAAAAAAAAAAAAA\' ``` ##### Note that access tokens are not long-living tokens. The lifetime of them differs from client to client, but they may last as short as 15 minutes (if you would like an increase in time, please reach out to us). ### Comparators ##### Filter parameters need to be formatted with a comparator and value in the format of \"COMPARATOR:VALUE\". The following is a list of possible values:  ##### GTE - Greater than or equal ##### GT - Greater than ##### LT - Less Than ##### LTE - Less than or equal ##### EQ - Equal ##### NQ - Not Equal ##### LK - Like ##### NLK - Not Like ##### EMPTY - Is null ##### NEMPTY - Is not null ## Subject to Change ##### Note that this API is in active development and may be subject to changes at any time. ##### This document is a living document with current specifications. If your integration does not seem to work properly, please refer back to this page to look for updates. ##### If you are still having issues, please reach out to support. 
 *
 * The version of the OpenAPI document: 2
 * Contact: support@enter.health
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
import {
    ExperimentStatusEnum,
    ExperimentStatusEnumFromJSON,
    ExperimentStatusEnumToJSON,
    SupportExperimentTemplate,
    SupportExperimentTemplateFromJSON,
    SupportExperimentTemplateToJSON,
    SupportFacility,
    SupportFacilityFromJSON,
    SupportFacilityToJSON,
    SupportPayer,
    SupportPayerFromJSON,
    SupportPayerToJSON,
    SupportProvider,
    SupportProviderFromJSON,
    SupportProviderToJSON,
    SupportUser,
    SupportUserFromJSON,
    SupportUserToJSON,
} from './';

/**
 * 
 * @export
 * @interface SupportExperiment
 */
export interface SupportExperiment {
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportExperiment
     */
    id?: string;
    /**
     * 
     * OpenAPI data type: {boolean}
     * @type {boolean}
     * @memberof SupportExperiment
     */
    active?: boolean;
    /**
     * The number of claims that have been allocated to this experiment.
     * OpenAPI data type: {integer}
     * @type {number}
     * @memberof SupportExperiment
     */
    numberOfAllocations?: number;
    /**
     * The maximum number of claims that can be allocated to this experiment. Additional claims can still be run against this experiment, but their statuses will not be checked.
     * OpenAPI data type: {integer}
     * @type {number}
     * @memberof SupportExperiment
     */
    maxNumberOfAllocations?: number;
    /**
     * 
     * OpenAPI data type: {SupportExperimentTemplate}
     * @type {SupportExperimentTemplate}
     * @memberof SupportExperiment
     */
    experimentTemplate?: SupportExperimentTemplate;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof SupportExperiment
     */
    created?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof SupportExperiment
     */
    updated?: string;
    /**
     * 
     * OpenAPI data type: {ExperimentStatusEnum}
     * @type {ExperimentStatusEnum}
     * @memberof SupportExperiment
     */
    status?: ExperimentStatusEnum;
    /**
     * 
     * OpenAPI data type: {SupportUser}
     * @type {SupportUser}
     * @memberof SupportExperiment
     */
    experimentOwner?: SupportUser;
    /**
     * 
     * OpenAPI data type: {SupportPayer}
     * @type {SupportPayer}
     * @memberof SupportExperiment
     */
    primaryPayer?: SupportPayer;
    /**
     * 
     * OpenAPI data type: {SupportProvider}
     * @type {SupportProvider}
     * @memberof SupportExperiment
     */
    billingProvider?: SupportProvider;
    /**
     * 
     * OpenAPI data type: {SupportProvider}
     * @type {SupportProvider}
     * @memberof SupportExperiment
     */
    renderingProvider?: SupportProvider;
    /**
     * 
     * OpenAPI data type: {SupportFacility}
     * @type {SupportFacility}
     * @memberof SupportExperiment
     */
    facility?: SupportFacility;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof SupportExperiment
     */
    fromDateOfService?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof SupportExperiment
     */
    throughDateOfService?: string;
    /**
     * 
     * OpenAPI data type: {boolean}
     * @type {boolean}
     * @memberof SupportExperiment
     */
    cancelRequested?: boolean;
}

export function SupportExperimentFromJSON(json: any): SupportExperiment {
    return {
            'id': !exists(json, 'id') ? undefined : json['id'],
            'active': !exists(json, 'active') ? undefined : json['active'],
            'numberOfAllocations': !exists(json, 'numberOfAllocations') ? undefined : json['numberOfAllocations'],
            'maxNumberOfAllocations': !exists(json, 'maxNumberOfAllocations') ? undefined : json['maxNumberOfAllocations'],
            'experimentTemplate': !exists(json, 'experimentTemplate') ? undefined : SupportExperimentTemplateFromJSON(json['experimentTemplate']),
            'created': !exists(json, 'created') ? undefined : json['created'],
            'updated': !exists(json, 'updated') ? undefined : json['updated'],
            'status': !exists(json, 'status') ? undefined : ExperimentStatusEnumFromJSON(json['status']),
            'experimentOwner': !exists(json, 'experimentOwner') ? undefined : SupportUserFromJSON(json['experimentOwner']),
            'primaryPayer': !exists(json, 'primaryPayer') ? undefined : SupportPayerFromJSON(json['primaryPayer']),
            'billingProvider': !exists(json, 'billingProvider') ? undefined : SupportProviderFromJSON(json['billingProvider']),
            'renderingProvider': !exists(json, 'renderingProvider') ? undefined : SupportProviderFromJSON(json['renderingProvider']),
            'facility': !exists(json, 'facility') ? undefined : SupportFacilityFromJSON(json['facility']),
            'fromDateOfService': !exists(json, 'fromDateOfService') ? undefined : json['fromDateOfService'],
            'throughDateOfService': !exists(json, 'throughDateOfService') ? undefined : json['throughDateOfService'],
            'cancelRequested': !exists(json, 'cancelRequested') ? undefined : json['cancelRequested'],
    };

}

export function SupportExperimentToForm(value?: SupportExperiment): any {
    let jsonVal = SupportExperimentToJSON(value);
    let retVal = '';
    if(jsonVal !== undefined && jsonVal != null) {
        Object.keys(jsonVal).forEach((v, i) => {
            if(i > 0) retVal+= "&";
            retVal+= encodeURIComponent(v) + "=" + encodeURIComponent(jsonVal[v]);
        });
    }
    return retVal;
}

function cleanupBlankValuesForBackend(val?:any): any {
    if(val instanceof Array) {
        return (val as Array<any>).filter((val) => { return val !== undefined && val !== null && val !== ''});
    } else {
        return (val === '') ? null : val;
    }
}

export function SupportExperimentToJSON(value?: SupportExperiment): any {
    value = cleanupBlankValuesForBackend(value);
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
            'id': cleanupBlankValuesForBackend(value.id),
            'active': cleanupBlankValuesForBackend(value.active),
            'numberOfAllocations': cleanupBlankValuesForBackend(value.numberOfAllocations),
            'maxNumberOfAllocations': cleanupBlankValuesForBackend(value.maxNumberOfAllocations),
            'experimentTemplate': SupportExperimentTemplateToJSON(value.experimentTemplate),
            'created': cleanupBlankValuesForBackend(value.created),
            'updated': cleanupBlankValuesForBackend(value.updated),
            'status': ExperimentStatusEnumToJSON(value.status),
            'experimentOwner': SupportUserToJSON(value.experimentOwner),
            'primaryPayer': SupportPayerToJSON(value.primaryPayer),
            'billingProvider': SupportProviderToJSON(value.billingProvider),
            'renderingProvider': SupportProviderToJSON(value.renderingProvider),
            'facility': SupportFacilityToJSON(value.facility),
            'fromDateOfService': cleanupBlankValuesForBackend(value.fromDateOfService),
            'throughDateOfService': cleanupBlankValuesForBackend(value.throughDateOfService),
            'cancelRequested': cleanupBlankValuesForBackend(value.cancelRequested),
    };
}


